import { EuiButton,EuiFlexGroup, EuiFlexItem, EuiFlyout, EuiFlyoutBody, EuiFlyoutHeader, EuiTitle } from "@elastic/eui";
import React,{ useEffect, useState } from "react";
import FiltrosMenu from "../Menus/filtros";
import { GridResultsScreen } from "./Grid/GridResultsScreen";
import './style.css';

export const HorasUserScreen = (props) =>{
    const {data,user,handleGetData,dateInit} = props;
    const [isFlyoutVisible, setIsFlyoutVisible] = useState(false);

    const closeFlyout = () => setIsFlyoutVisible(false);
    const showFlyout = () => {setIsFlyoutVisible(true);handleGetData()}

    const onFilterData = (dataFilter)=>{
        const {fechaDesde,fechaHasta}=dataFilter
        handleGetData({fechaDesde,fechaHasta});
    }

    let flyout;
    if (isFlyoutVisible) {
        flyout = (
        <EuiFlyout
            ownFocus
            onClose={closeFlyout}
            size='m'
            maxWidth={true}
            aria-labelledby="flyoutLargeTitle">
            <EuiFlyoutHeader hasBorder>
            <EuiTitle size="m">
                <h2 id="flyoutTitleHorasUser">{`Horas No Imputadas de `}<span>{`${user}`}</span></h2>
            </EuiTitle>
            </EuiFlyoutHeader>
            <EuiFlyoutBody>
                <EuiFlexGroup direction='column'>
                    <EuiFlexItem><FiltrosMenu dateInit={dateInit} onChangeFilter={onFilterData}/></EuiFlexItem>
                    <EuiFlexItem><GridResultsScreen data={data}/></EuiFlexItem>
                </EuiFlexGroup>
            </EuiFlyoutBody>
        </EuiFlyout>
        );
    }

    return (
        <div>
            <EuiButton onClick={showFlyout} iconType="alert" color='danger' size={'s'} className='menuButton'>{'Horas'}</EuiButton>
            {flyout}
        </div>
  )
}